import { FieldEditAvatar } from "@/components/form/fields/FieldEditAvatar"
import { JSX } from "react"
import { Input, InputProps } from "@/components/ui/input"
import { UseFormReturn } from "react-hook-form"

export enum FieldEnum {
  Avatar = "avatar",
  Text = "text",
  //   Timestamp = "timestamp",
  //   SimpleTag = "simple-tag",
  //   Currency = "currency",
  //   Select = "select",
}

const USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
})

export interface EditableProps {
  inputProps?: InputProps
  onSubmit?: (values: any) => Promise<any>
  onCancel?: () => void
  form: UseFormReturn<any>
  extra?: {
    name?: string
  }
  //extends SelectOptionsProps {
  //   fieldProps: FieldProps
  //   formTools?: Partial<ReturnType<typeof useFormTools>>
  //   className?: string
}

export const Fields: {
  enum: Record<keyof typeof FieldEnum, FieldEnum>
  record: Record<
    FieldEnum,
    {
      label: string
      description: string
      icon?: any
      formatted?: (value: any) => string
      display?: (value: any) => any
      getEditable?: (props: EditableProps) => JSX.Element
    }
  >
} = {
  enum: FieldEnum,
  record: {
    [FieldEnum.Text]: {
      label: "Text",
      description: "Human-readable, unconstrained text inputs",
      //   icon: IconHugeiconsNote01,
      getEditable: (props) => {
        return <Input {...props.inputProps} />
      },
    },
    // [FieldEnum.Currency]: {
    //   label: "Text",
    //   description: "More than just numbers",
    //   icon: IconHugeiconsDollarCircle,
    //   formatted: (value) => {
    //     return USDollar.format(value || 0)
    //   },
    // },
    // [FieldEnum.Timestamp]: {
    //   label: "Timestamp",
    //   description: "A calendar date including time information, stored in UTC",
    //   icon: IconHugeiconsCalendar03,
    //   formatted: (value) => {
    //     if (!value) return ""
    //     return formatTimestampPretty(value)
    //   },
    // },
    // [FieldEnum.SimpleTag]: {
    //   label: "Tag",
    //   description: "A tag is a label that can be attached to a resource.",
    //   icon: IconHugeiconsLabel,
    //   display: (value) => SimpleTags({ tags: value }),
    //   formatted: (value) => {
    //     if (!value) return ""
    //     return value
    //       ?.split(",")
    //       .map((tag: string) => tag.trim())
    //       .join(", ")
    //   },
    // },
    // [FieldEnum.Select]: {
    //   label: "Select",
    //   description: "Select",
    //   icon: IconMageCaretDownFill,
    //   controlled: true,
    //   getEditable: (props) => {
    //     const { fieldProps, formTools, ...rest } = props
    //     return (
    //       <Field {...fieldProps} control>
    //         <SelectOptions {...rest} />
    //       </Field>
    //     )
    //   },
    // },
    [FieldEnum.Avatar]: {
      label: "Avatar",
      description: "Avatar",
      //   icon: IconHugeiconsUserCircle,
      display: (value) => value,
      getEditable: (props) => {
        return <FieldEditAvatar {...props} />
      },
    },
  },
} as const

export type FieldType = FieldEnum
